(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6890],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fterms.tsx&page=%2Fterms!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__("./src/pages/terms.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Elements/RelatedTopics/RelatedTopics.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _LinkElements_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/LinkElements/Link.tsx");




const RelatedTopics = (param)=>/*#__PURE__*/ {
    let { topics  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .VStack */ .gC, {
        position: "sticky",
        top: "100px",
        display: "inline-block",
        bgColor: "blackAlpha.50",
        _dark: {
            bgColor: "whiteAlpha.50"
        },
        p: 10,
        borderRadius: 12,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6, {
                as: "h2",
                size: "md",
                children: "Related Topics"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .iz, {
                filter: "brightness(0.9)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .List */ .aV, {
                spacing: 2,
                children: topics.map((topic)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .ListItem */ .HC, {
                        mt: "20px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkElements_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            href: topic.url,
                            scroll: !!topic.isSectionLink,
                            children: topic.name
                        })
                    }))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RelatedTopics);


/***/ }),

/***/ "./src/components/SEO/Static.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ CareersHeader; },
/* harmony export */   "BV": function() { return /* binding */ FaqSEO; },
/* harmony export */   "FV": function() { return /* binding */ TermsHeader; },
/* harmony export */   "Q_": function() { return /* binding */ GuidelinesHeader; },
/* harmony export */   "XJ": function() { return /* binding */ PrivacyPolicySEO; },
/* harmony export */   "d5": function() { return /* binding */ AboutHeader; }
/* harmony export */ });
/* unused harmony export CaPrivacyRightsHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");



const AboutHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "About",
        description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token.",
        canonical: "https://iq.wiki/static/about",
        openGraph: {
            title: "About",
            description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token."
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const FaqSEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "FAQ",
        description: "Frequently Asked Questions about IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/faq",
        openGraph: {
            title: "FAQ",
            description: "Frequently Asked Questions about IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const PrivacyPolicySEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Policy",
        description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/privacy",
        openGraph: {
            title: "Our Policy",
            description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CareersHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Jobs",
        description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/careers",
        openGraph: {
            title: "Jobs",
            description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CaPrivacyRightsHeader = ()=>/*#__PURE__*/ _jsx(NextSeo, {
        title: "CA Privacy Rights",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/CaPrivacyRights",
        openGraph: {
            title: "CA Privacy Rights",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const TermsHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Terms of Service ",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/terms",
        openGraph: {
            title: "Terms of Service",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const GuidelinesHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Guidelines",
        description: "IQ.Wiki guidelines for the community and network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/guidelines",
        openGraph: {
            title: "Our Guidelines",
            description: "IQ.Wiki guidelines for the community and network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });


/***/ }),

/***/ "./src/pages/terms.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _components_Elements_RelatedTopics_RelatedTopics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/RelatedTopics/RelatedTopics.tsx");
/* harmony import */ var _components_SEO_Static__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/components/SEO/Static.tsx");





const Terms = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_Static__WEBPACK_IMPORTED_MODULE_3__/* .TermsHeader */ .FV, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                w: "min(90%, 1200px)",
                maxW: {
                    base: "7xl",
                    xl: "6xl",
                    "2xl": "80%"
                },
                my: {
                    base: "10",
                    lg: "16"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        my: 8,
                        as: "h1",
                        size: "3xl",
                        letterSpacing: "wide",
                        children: "Terms of Service"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                        gap: 10,
                        flexDirection: {
                            base: "column",
                            lg: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                                gap: 5,
                                flex: "3",
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: 'Welcome to IQ.Wiki, the website and online service of Distributed Machines Inc. ("IQ.wiki," "we," "us" or "our"). This page explains the terms by which you may use our online and/or mobile services, website, and software provided on or in connection with the IQ.Wiki service (collectively the "Service"). By accessing or using the Service, you ("you" or "your"), signify that you have read, understand and agree to be bound by the terms of service and conditions set forth below (as amended from time to time, "Terms") and to the collection, use, and disclosure of your information as set forth in our Privacy Policy, as modified from time to time and which is incorporated by reference herein. These Terms apply to all visitors, users, and others who access the Service ("Users"). If you are a United States Federal Agency, this Amendment is applied to the Terms of Service. We provide the Service for your use subject to the following Terms. We reserve the right, in our sole discretion, to change or modify portions of these Terms at any time. If we modify these Terms, we will post a notice at the top of our Service for a period of seven (7) days. Your continued use of the Service constitutes your acknowledgement of, acceptance of, and agreement to the revised Terms. You agree to periodically visit this page to review the current Terms so you are aware of any revision to which you are bound. We will indicate at the top of this page the date these terms were last revised. If you do not agree to abide by these or any future Terms, do not use or access (or continue to use or access) the Service. IQ.wiki allows you to upload images, files, and other media. You agree to only upload images that you have the necessary licenses, and permissions, and rights, or that are in the public domain, or that you own. You must agree not to upload any copyrighted image unless you were permitted by the owner of the image or you are legally otherwise entitled to upload the image. IQ.wiki takes no responsibility for any liability you may or may not incur from uploading images for which you do not have the necessary licenses, permissions, and/or rights. Additional terms and conditions may apply to certain services provided by IQ.wiki, and you agree that you shall be subject to any additional terms applicable to such services that may be posted on the Website or otherwise made available to you from time to time. All such terms are hereby incorporated by reference into these Terms. PLEASE READ THESE TERMS CAREFULLY TO ENSURE THAT YOU UNDERSTAND EACH PROVISION. THESE TERMS CONTAIN A MANDATORY INDIVIDUAL ARBITRATION AND CLASS ACTION/JURY TRIAL WAIVER PROVISION THAT REQUIRES THE USE OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR CLASS ACTIONS. THE SERVICE MAY CONTAIN CONTENT THAT IS INACCURATE, OBJECTIONABLE, INAPPROPRIATE FOR CHILDREN, OR OTHERWISE UNSUITED TO YOUR PURPOSE, AND YOU AGREE THAT IQ.wiki SHALL NOT BE LIABLE FOR ANY DAMAGES YOU ALLEGE IN INCUR AS A RESULT OF ANY EXPOSURE TO SUCH CONTENT. YOU USE THE SERVICE AT YOUR OWN RISK.'
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                                        as: "h2",
                                        size: "md",
                                        children: "Eligibility"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: "This Service is intended solely for users who are 13 years of age or older. Any registration by, use of or access to the Service by anyone under 13 is unauthorized and in violation of these Terms. By using the Service, you represent and warrant that you are 13 years of age or older."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                                        as: "h2",
                                        size: "md",
                                        children: "Access and Use of the Service"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: "IQ.wiki is a cryptocurrency encyclopedia. We welcome your participation in this quest subject to these Terms. Registration may not be required to view content on the Service, but even unregistered Users are bound by these Terms. Subject to the terms and conditions of these Terms, you are hereby granted a non-exclusive, limited, non-transferable, freely revocable license to use the Service as permitted by the features of the Service. IQ.wiki reserves all rights not expressly granted herein in the Service and the IQ.wiki Content (as defined below). IQ.wiki may terminate this license at any time for any reason or no reason."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                children: "Your Registration Obligations:"
                                            }),
                                            ' Your IQ.wiki account gives you access to the services and functionality that we may establish and maintain from time to time and in our sole discretion. We may maintain different types of accounts for different types of Users. If you open an IQ.wiki account on behalf of a company, organization, school, or other entity, then (i) "you" includes you and that entity, and (ii) you represent and warrant that you are an authorized representative of the entity with the authority to bind the entity to this Agreement, and that you agree to this Agreement on the entity\'s behalf. Without limiting the generality of the foregoing, if you are a teacher or other representative of a school and/or district, you represent and warrant that you have permission from your school and/or district to enter into these Terms and to use the Service as part of your curriculum. If you choose to register for an account, you agree to provide and maintain true, accurate, current and complete information about yourself as prompted by our registration form. The information you submit to us when you register ("Registration Data") and certain other information about you are governed by our Privacy Policy as well as these Terms, as discussed above. By using the Service you consent to having Registration Data and other data you submit transferred to and processed within the United States.'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                children: "Member Account, Password and Security:"
                                            }),
                                            " You are responsible for maintaining the confidentiality of your password and account, if any, and are fully responsible for any and all activities that occur under your password or account. You agree to (a) immediately notify IQ.wiki of any unauthorized use of your password or account or any other breach of security, and (b) ensure that you exit from your account at the end of each session when accessing the Service. IQ.wiki will not be liable for any loss or damage arising from your failure to comply with this Section."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                                        as: "h2",
                                        size: "md",
                                        children: "Copyright / Repeat Infringement"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: "IQ.wiki responds to copyright complaints submitted under the Digital Millennium Copyright Act (“DMCA”). Section 512 of the DMCA outlines the statutory requirements needed for the formal reporting of copyright infringement, as well as providing instructions on how an affected party can appeal a removal by submitting a compliant counter-notice. IQ.wiki will respond to reports of copyright infringement, allegations concerning the unauthorized use of a copyrighted video, image, or other file uploaded through our media hosting services, or pages containing links to allegedly infringing materials."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: "By using IQ.wiki, you have agreed to our Terms of Service, which prohibit people from taking any action on IQ.wiki that infringes or violates someone else's intellectual property rights or otherwise violates the law. If you repeatedly post content that infringes someone else’s intellectual property rights, such as copyrights or trademarks, your IP address may be banned and your page removed under IQ.wiki's repeat infringer policy. If you believe your IP address was banned by mistake, please contact us."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                                        as: "h2",
                                        size: "md",
                                        children: "Designated Agent"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: [
                                            "You can mail copyright complaints to: ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "2300 West Sahara Ave., Suite 800 ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "PMB 214 ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "Las Vegas, NV 89102 ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "or via email: webmaster@iq.wiki ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "or submit them via the",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                color: "brandLinkColor",
                                                href: "https://forms.gle/WivCngAngW19kGMn9",
                                                children: "IQ.wiki Content Removal form"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                children: "Modifications to Service:"
                                            }),
                                            " IQ.wiki reserves the right to modify or discontinue, temporarily or permanently, the Service (or any part thereof) or any User account with or without notice. You agree that IQ.wiki shall not be liable to you or to any third party for any modification, suspension or discontinuance of the Service."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                        children: [
                                            "IQ.wiki's Content: IQ.wiki's articles are licensed under a",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                                color: "brandLinkColor",
                                                href: "https://creativecommons.org/licenses/by/4.0/",
                                                children: "Creative Commons Attribution 4.0 International License."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_RelatedTopics_RelatedTopics__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    topics: [
                                        {
                                            name: "Privacy Policy",
                                            url: "/privacy"
                                        },
                                        {
                                            name: "Guidelines",
                                            url: "/guidelines"
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
/* harmony default export */ __webpack_exports__["default"] = (Terms);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fterms.tsx&page=%2Fterms!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);